<template>
    <div class="calendar-date-selector">
        <button @click="selectPrevious" :disabled="disablePrevious" :class="{'disabled': disablePrevious}"> &lt; </button>
        <span @click="selectCurrent">Today</span>
        <button @click="selectNext" :disabled="disableNext" :class="{'disabled': disableNext}"> &gt; </button>
    </div>
</template>

<script>
import dayjs from "dayjs";

export default {
    name: "CalendarModeSelector",

    props: {
        currentDate: {
            type: String,
            required: true
        },

        selectedDate: {
            type: Object,
            required: true
        },
        disableNext: {
            type: Boolean,
            default: false
        },
        disablePrevious: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        selectPrevious() {
            let newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
            this.$emit("dateSelected", newSelectedDate);
        },

        selectCurrent() {
            let newSelectedDate = dayjs(this.currentDate);
            this.$emit("dateSelected", newSelectedDate);
        },

        selectNext() {
            let newSelectedDate = dayjs(this.selectedDate).add(1, "month");
            this.$emit("dateSelected", newSelectedDate);
        }
    }
};
</script>
